import React from 'react';

import Theme from 'Theme';

import PrimaryButton from './Primary';
import { Input } from './Styled';

export const getButton = (type) => {
  switch (type) {
    case 'Warning':
      return Warning;
    default:
      return Default;
  }
};

export const Step = (props) => (
  <PrimaryButton {...props} color={Theme.primaryColor} />
);

export const Back = (props) => (
  <PrimaryButton {...props} secondary border color={Theme.brandColor} />
);

export const Warning = (props) => (
  <PrimaryButton {...props} icon={'close'} color={Theme.dangerColor} />
);

export const Primary = (props) => (
  <PrimaryButton color={Theme.brandColor} {...props} />
);

export const Default = (props) => <PrimaryButton {...props} />;

export const Cancel = (props) => (
  <PrimaryButton
    {...props}
    border
    secondary
    label={props.label || 'Cancel'}
    color={props.color || 'rgb(45,68,83, 0.5)'}
  />
);

export const Upload = ({ label, loading, onChange, pendingFile }) => (
  <PrimaryButton
    disabled={!!loading}
    border={pendingFile}
    secondary={pendingFile}
    color={Theme.brandColor}
    hoverColor={Theme.brandColorAccent}
    label={label || pendingFile ? 'Change File' : 'Choose File'}
  >
    <Input value={''} type={'file'} onChange={onChange} />
  </PrimaryButton>
);
